module.exports = __webpack_public_path__ + "assets/img/37_1586.b4981147.jpg";